package uk.co.nickthecoder.kyd.json

import uk.co.nickthecoder.glok.backend.Resources
import uk.co.nickthecoder.glok.util.log
import uk.co.nickthecoder.kojak.JsonObject
import uk.co.nickthecoder.kyd.Game

/**
 * In an attempt to ensure that old versions of .kyd files will be backwards compatible with newer versions
 * of Kyd, there can be many instances of this interface, each one is capable of parsing/creating a certain flavour
 * of Json file.
 */
interface GameFileVersion {

    val version: String

    fun gameFromJson(jGame: JsonObject, filePath: String, resources: Resources, editor: Boolean): Game

    fun Game.toJson(): JsonObject

}


private fun gameFileVersion(versionString: String): GameFileVersion {
    return when (versionString) {
        "1" -> GameFileVersion1()
        else -> {
            log.warn("Version '$versionString' not known. Trying version '1'")
            GameFileVersion1()
        }
    }
}

private fun gameFileVersion(jGame: JsonObject): GameFileVersion =
    gameFileVersion(jGame.getString("version", "?"))


fun createJson(game: Game): JsonObject = with(GameFileVersion1()) {
    game.toJson()
}

fun createGameFromJson(jGame: JsonObject, filePath: String, resources: Resources, editor: Boolean): Game {

    with(gameFileVersion(jGame)) {
        return gameFromJson(jGame, filePath, resources, editor)
    }

}
